const routes = [{
  path: '/finance/index',
  component: () => import('@/views/feiche/index'),
  name: 'finance-index',
  meta: {
    title: ''
  }
}, {
  path: '/finance/settlement',
  component: () => import('@/views/finance/settlement'),
  name: 'finance-settlement',
  meta: {
    title: '财务管理/结算查询'
  }
}, {
  path: '/finance/convert',
  component: () => import('@/views/finance/convert'),
  name: 'convert',
  meta: {
    title: '业财转换'
  }
}, {
  path: '/finance/salesSettlement',
  component: () => import('@/views/finance/salesSettlement'),
  name: 'salesSettlement',
  meta: {
    title: '产销结算'
  }
}, {
  path: '/finance/convert/init',
  component: () => import('@/views/finance/convert/init'),
  name: 'convert-init',
  meta: {
    title: '业财转换/业财对接初始化'
  }
}, {
  path: '/finance/setting',
  component: () => import('@/views/finance/setting'),
  name: 'finance-setting',
  meta: {
    title: '上游结算'
  }
}, {
  path: '/finance/supplier/settlement',
  component: () => import('@/views/finance/settlement/supplier'),
  name: 'finance-supplier-settlement',
  meta: {
    title: '上游结算'
  }
}, {
  path: '/finance/detail/report',
  component: () => import('@/views/finance/settlement/finance'),
  name: 'finance-settlement-detail',
  meta: {
    title: '财务明细报表'
  }
}, {
  path: '/finance/salesman/settlement',
  component: () => import('@/views/finance/salesman'),
  name: 'finance-salesman-settlement',
  meta: {
    title: '下游结算'
  }
}, {
  path: '/finance/salesman/reconciliation',
  component: () => import('@/views/finance/salesman/reconciliation'),
  name: 'finance-salesman-reconciliation',
  meta: {
    title: '下游对账'
  }
}, {
  path: '/finance/reward/settlement',
  component: () => import('@/views/finance/reward'),
  name: 'finance-reward-settlement',
  meta: {
    title: '多级结算'
  }
}, {
  path: '/finance/visualization',
  component: () => import('@/views/finance/visualization'),
  name: 'finance-visualization',
  meta: {
    title: '业务费用额度报表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/finance/finance.js